import React from 'react';
import {
    ServicesPerMonthPerYearPercentage,
    ServicesPerYearPercentage
} from '../../../../Common/Services/charts/apex-charts';
import { useServicesChartsDataContext } from '../../../../Common/Services/hooks/useServicesChartsDataContext';
import Loading from '../../../../Common/Loading';
import { ServicesPerYearDonut } from '../../../../Common/Services/charts/apex-charts/ServicesPerYearDonut';

const Services = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-row-dashboards">
                <ServicesPerYearDonut height={400} />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearPercentage height={400} />
                <ServicesPerMonthPerYearPercentage height={400} />
            </div>
        </>
    );
};

export default Services;
